var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrave = function SvgBrave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brave_svg__a)",
    d: "m20.36 6.531.496-1.21s-.625-.669-1.393-1.433c-.769-.764-2.387-.318-2.387-.318L15.236 1.5H8.75L6.906 3.586s-1.617-.446-2.386.318c-.768.764-1.393 1.433-1.393 1.433l.497 1.21L3 8.33s1.858 6.974 2.066 7.833c.432 1.672.72 2.325 1.938 3.185s3.41 2.324 3.779 2.547c.352.223.817.605 1.217.605s.849-.382 1.217-.605a213 213 0 0 0 3.78-2.547c1.217-.844 1.505-1.497 1.937-3.185C19.158 15.303 21 8.33 21 8.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.564 4.907s2.37 2.85 2.37 3.47c0 .622-.304.765-.608 1.083-.305.319-1.618 1.704-1.778 1.879-.176.175-.512.446-.32.94.208.477.512 1.098.176 1.735-.336.62-.913 1.05-1.281.971-.369-.064-1.25-.525-1.57-.732s-1.329-1.035-1.329-1.354c0-.318 1.057-.891 1.25-1.019.191-.127 1.072-.637 1.088-.828s.016-.254-.256-.748c-.256-.493-.737-1.146-.657-1.576s.833-.653 1.378-.86 1.585-.589 1.713-.653c.128-.063.096-.111-.304-.159-.4-.032-1.505-.19-2.018-.048-.512.144-1.361.35-1.441.462-.064.112-.128.112-.064.51.064.382.448 2.26.48 2.595.032.334.112.557-.256.637-.352.08-.96.223-1.17.223-.207 0-.816-.144-1.168-.223s-.288-.303-.256-.637.4-2.197.48-2.595c.064-.382.016-.398-.064-.51-.064-.111-.929-.318-1.441-.462-.513-.143-1.618 0-2.018.048-.4.032-.432.096-.304.16.128.063 1.169.445 1.713.652.545.207 1.297.43 1.377.86s-.384 1.083-.656 1.576c-.256.494-.272.541-.256.748.016.191.896.701 1.089.828.192.128 1.249.7 1.249 1.02 0 .318-1.01 1.146-1.33 1.353s-1.185.652-1.569.732c-.368.064-.945-.35-1.281-.971s-.032-1.242.176-1.736c.208-.477-.144-.748-.32-.939-.128-.191-1.425-1.576-1.73-1.879-.304-.318-.592-.477-.592-1.082s2.37-3.471 2.37-3.471 2.002.382 2.274.382.849-.223 1.393-.398c.545-.175.897-.175.897-.175s.352 0 .897.175c.544.175 1.12.398 1.393.398s2.274-.382 2.274-.382m-1.778 10.906c.145.095.065.27-.08.35-.128.096-1.937 1.48-2.097 1.64-.177.16-.433.398-.609.398s-.432-.255-.609-.398c-.176-.16-1.97-1.544-2.097-1.64-.129-.095-.225-.27-.08-.35.144-.096.608-.319 1.233-.653.64-.334 1.425-.605 1.553-.605s.913.27 1.553.605c.625.334 1.073.573 1.233.653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#brave_svg__b)",
    d: "M17.077 3.586 15.234 1.5H8.75L6.906 3.586s-1.617-.446-2.386.318c0 0 2.162-.191 2.899 1.003 0 0 2.002.382 2.274.382s.849-.223 1.393-.398c.545-.175.897-.175.897-.175s.352 0 .897.175c.544.175 1.12.398 1.393.398s2.274-.382 2.274-.382c.737-1.194 2.899-1.003 2.899-1.003-.753-.764-2.37-.318-2.37-.318"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brave_svg__a",
    x1: 3,
    x2: 20.986,
    y1: 11.996,
    y2: 11.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FF2000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brave_svg__b",
    x1: 4.849,
    x2: 19.457,
    y1: 3.391,
    y2: 3.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF452A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })))));
};
export default SvgBrave;